import { AutogenLayoutMobileCommControlTest } from "./autogen/AutogenLayoutMobileCommControlTest";

export class MobileCommControlTest extends AutogenLayoutMobileCommControlTest {

    async onLoad() {
    }
}
